import { useEffect } from "react"

import { useAuth } from "@/components/AuthProvider"
import { appUrl } from "@/lib/app-links"
import { isLaunchMode } from "@/lib/launch-config"
import { ComingSoonLandingPage } from "@/pages/marketing/ComingSoonLandingPage"
import { LandingPage } from "@/pages/marketing/LandingPage"

/** Public marketing home at `/`. Launch mode shows coming-soon for visitors and
 *  bounces signed-in users to the app; once fully live, `/` stays the marketing
 *  homepage for everyone, signed in or not.
 *
 *  Renders the logged-out marketing page immediately instead of gating on
 *  `loading` -- this route is prerendered as a logged-out visitor, so
 *  waiting on `loading` here would mismatch that static markup on the
 *  client's first hydration pass (auth starts `loading: true` client-side).
 *  A signed-in visitor in launch mode still gets sent to the app, just once
 *  the session check resolves rather than before first paint.
 *
 *  The app is its own deployment on its own origin, so that hand-off is a
 *  real navigation (`window.location`) rather than a router `<Navigate>` --
 *  there is no `/workspaces` route on this site to navigate to. */
export function HomeEntry() {
  const { user, loading } = useAuth()
  const leaveForApp = isLaunchMode() && !loading && Boolean(user)

  useEffect(() => {
    if (!leaveForApp) return
    window.location.replace(appUrl("/workspaces"))
  }, [leaveForApp])

  if (isLaunchMode()) return <ComingSoonLandingPage />

  return <LandingPage />
}
